import React from 'react';
import cx from 'classnames';
import Link from 'next/link';

import { applyCypressData } from 'Utilities/helpers';
import useKeyboardNavigation from 'Utilities/hooks/useKeyboardNavigation';

import { BODY_ROW_ARIA_INDEX_OFFSET } from '../../Datagrid.consts';
import type { DatagridRowProps } from '../../Datagrid.types';

import styles from './DatagridRow.module.scss';

export const DatagridRow: React.FC<DatagridRowProps> = ({
	as,
	children,
	cypressId = 'datagrid-row',
	gridClass,
	href,
	id,
	index,
	isActive,
	isInteractive = true,
	onClick,
	target,
}) => {
	const isLink = as && href;

	const onClickHandler = () => {
		if (isInteractive) {
			onClick?.();
		}
	};

	const { onKeyDown, onKeyUp } = useKeyboardNavigation(onClickHandler);

	const commonProps = {
		'aria-rowindex': index + BODY_ROW_ARIA_INDEX_OFFSET, // offset by 2 to account for header
		className: cx(styles.datagridRow, gridClass, {
			[styles.interactive]: isInteractive,
			[styles.isActive]: isActive,
		}),
		'data-rowindex': index,
		id,
		role: 'row',
		tabIndex: 0,
		...(isInteractive && { onClick: onClickHandler }),
		...(!isLink && { onKeyDown, onKeyUp }),
		...applyCypressData(cypressId),
	};

	return isInteractive && isLink ? (
		<Link passHref as={as} href={href} target={target} {...commonProps}>
			{children}
		</Link>
	) : (
		<div {...commonProps} role="row">
			{children}
		</div>
	);
};
